import type { TimelineEntity, TimelineItem, TimelineRegistry } from './types';

const useTimelineRegistryHelper = (registries: TimelineRegistry[]) => {
  const getRegistry = (item: TimelineEntity | TimelineItem) => {
    return registries.find(registry => registry.isApplicable(item));
  };

  return {
    getRegistry,
  };
};

export type { TimelineRegistry };
export default useTimelineRegistryHelper;
